import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiTag } from 'react-icons/fi';

const CTASection = () => {
  const checkoutUrl = "https://encouragingbv.gumroad.com/l/biblebookmark";

  return (
    <section className="py-24 bg-stone-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1507842217343-583bb7270b66?q=80&w=2000&auto=format&fit=crop" 
          alt="Library Background" 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">
          Keep His Word Close at Hand
        </h2>
        <p className="text-xl text-stone-300 mb-8 max-w-2xl mx-auto">
          Download your Bible Emergency Numbers bundle today and start printing beautiful, comforting gifts for yourself and your loved ones.
        </p>

        <div className="mb-10 flex flex-col items-center">
          <div className="flex items-center gap-4 mb-2">
            <span className="text-5xl font-bold text-amber-400">$2.99</span>
            <div className="text-left">
              <span className="block text-stone-500 line-through text-xl decoration-stone-400 decoration-2">$45.00</span>
              <span className="text-amber-200/80 text-sm font-bold uppercase tracking-wider">Limited Time Sale</span>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10 text-stone-300 text-sm flex items-center gap-2">
            <SafeIcon icon={FiTag} className="text-amber-400" />
            Includes 8 Bonus Designs + Lifetime Updates
          </div>
        </div>

        <div className="flex flex-col items-center gap-4">
          <a 
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amber-500 hover:bg-amber-400 text-stone-900 px-10 py-5 rounded-xl font-bold text-xl transition-all shadow-xl shadow-amber-500/20 hover:shadow-2xl hover:-translate-y-1 w-full sm:w-auto inline-block text-center"
          >
            Get Instant Access Now
          </a>
          <span className="text-stone-400 text-sm">One-time payment. Lifetime access to the digital files.</span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;